import { configureStore } from '@reduxjs/toolkit';
import exampleReducer from './exampleSlice';
import userReducer from './userSlice';
import actionsDateFiltersReducer from "./actionsDateFiltersSlice";
import alertsFiltersOptionsReducer from "./alertsFiltersOptionsSlice";
import updateAlertStatusActionReducer from "./updateAlertStatusActionSlice";
import initialFiltersReducer from "./euqipmentFiltersSlice";
import siteIdReducer from "./siteIdSlice";
import timeZoneReducer from './timeZoneSlice';
import actionsSelectedDateReducer from './actionsSelectedDateSlice';
import siteTypesReducer from './siteTypeSlice';
import analyticsSelectionsSlice from './analyticsSelections';
import peakUsageSelectedDateSlice from "./peakUsageSelectedDate";

const store = configureStore({
  reducer: {
    example: exampleReducer,
    user: userReducer,
    actionsDateFilters: actionsDateFiltersReducer,
    alertsFiltersOptions: alertsFiltersOptionsReducer,
    updateAlertStatusAction: updateAlertStatusActionReducer,
    equipmentFilters: initialFiltersReducer,
    siteId: siteIdReducer,
    siteTypes: siteTypesReducer,
    timeZone: timeZoneReducer,
    actionsSelectedDate: actionsSelectedDateReducer,
    analyticsSelections: analyticsSelectionsSlice,
    peakUsageSelectedDate: peakUsageSelectedDateSlice
  },
});

export default store;
